import { render, staticRenderFns } from "./SampleCallPopup.vue?vue&type=template&id=552cbfd6&"
import script from "./SampleCallPopup.vue?vue&type=script&lang=js&"
export * from "./SampleCallPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-user-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('552cbfd6')) {
      api.createRecord('552cbfd6', component.options)
    } else {
      api.reload('552cbfd6', component.options)
    }
    module.hot.accept("./SampleCallPopup.vue?vue&type=template&id=552cbfd6&", function () {
      api.rerender('552cbfd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/druginfo/SampleCallPopup.vue"
export default component.exports